export default "__VITE_ASSET__BTxpS4K6__"